import { CURRENCY_SYMBOL,COUNTRY_CODE,APP_COUNTRY,CURRENCY_CODE } from './constant';
import secureStorage from './encrypt';
import { toast } from 'react-toastify';
import forge from 'node-forge';

export const isUserHasAccessPage = (params: { permissionID: string | number, accessType: any, assignUserId?: string | null | undefined }) => {
    let { permissionID, accessType, assignUserId } = params;

    let isAuthorized = false;
    let authUserInfo = secureStorage.getItem('authUserInfo');
    let userDetails = authUserInfo && authUserInfo.user_data;
    if (permissionID) {
        const accessParams = (userDetails && userDetails.feature_access) ? userDetails?.feature_access?.filter((feature: any) => +feature?.assigned_feature_ids === +permissionID) : [];
        if (accessParams && accessParams[0]) {

            let checkEditAccess = accessParams?.filter((feature: any) => ([1, 2].includes(+feature.assigned_role_id) && feature.canEdit) || (assignUserId && [3].includes(+feature.assigned_role_id) && '' + assignUserId === '' + userDetails.id && feature.canEdit) || (![1, 2, 3].includes(+feature.assigned_role_id) && feature.canEdit))
            let checkViewAccess = accessParams?.filter((feature: any) => ([1, 2].includes(+feature.assigned_role_id) && feature.canView) || (assignUserId && [3].includes(+feature.assigned_role_id) && '' + assignUserId === '' + userDetails.id && feature.canView) || (![1, 2, 3].includes(+feature.assigned_role_id) && feature.canView))
            
            if (accessType === 'edit' && checkEditAccess.length) {
                isAuthorized = true;

            }
            else if (accessType === 'view' && checkViewAccess.length && userDetails.assigned_role_ids.indexOf("3") >= 0) {
                isAuthorized = true;
            }
            else if (accessType === 'isVisible') {
                isAuthorized = true;
            }
        }
    }

    return isAuthorized;
}

export const addCurrencyFormatting = (number: any) => {
    number = number ? number.toString().replace(/,/g, '') : 0;
    if(COUNTRY_CODE === APP_COUNTRY.APP_TYPE_ID){
        return CURRENCY_SYMBOL + ' ' + (+number ? (+number).toLocaleString(CURRENCY_CODE) : 0);
    }
    return CURRENCY_SYMBOL + ' ' + (+number ? (+number).toLocaleString("en-EU") : 0);
}

export const getOrdinal = (n: number) => {
  const s = ["th", "st", "nd", "rd"];
  const v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
}

export const  handleCopyText = (text: string) => {
    if (!text) return;
    navigator.clipboard.writeText(text)
        .then(() => {
            toast.success("Copied!");
        })
    .catch((err) => {
        console.error("Failed to copy: ", err);
    });
}

export const navigatePermssion = (navigate: (path: string) => void) =>{
    const authUserInfo = secureStorage.getItem("authUserInfo");
    const role_id = authUserInfo?.user_data?.assigned_role_ids;
    if(authUserInfo && role_id){
        const roleName = normalizeRoleName(authUserInfo?.user_data?.assigned_role_name);
        switch (roleName) {
            case 'ADMIN':
            case 'SALES_HEAD':
            case 'SALES_MANAGER':
            case 'COLLECTIONS_AGENT':
                navigate(`/lead-list`)
            break;
            case 'FINANCE_TEAM':
                navigate(`/payment-list`);
            break;
            case 'RECO_TEAM':
                navigate(`/reconciliation-list`);
            break;
            case 'REM_OPS':
                navigate(`/remittance-list`);
            break;
            case 'REM_FINANCE_MAKER':
                navigate(`/remittance-list`);
            break;
            case 'REM_FINANCE_CHECKER':
                navigate(`/remittance-list`);
            break;
        
            default:
                navigate(`/login`);
                break;
        }
    }else{
        navigate(`/login`)
    }


}

export function normalizeRoleName(role: string): string {
  return role.trim().toUpperCase().replace(/\s+/g, "_");
}

export const allowAlphaNumericKeys = (
  e: React.KeyboardEvent<HTMLInputElement>,
  extraAllowedKeys: string[] = []
) => {
  if (extraAllowedKeys.includes(e.key)) return;

  const isPaste =
    (e.ctrlKey || e.metaKey) && (e.key.toLowerCase() === "v" || e.key.toLowerCase() === "c");
  if (isPaste) return;

  const allowedKeys = ["Backspace", "Delete", "Tab", "ArrowLeft", "ArrowRight"];

  // Block anything that is NOT a letter or digit
  if (!/^[a-zA-Z0-9]$/.test(e.key) && !allowedKeys.includes(e.key)) {
    e.preventDefault();
  }
};

export const decryptResponseData = (encryptedData:any, iv:any, symmetricKey:any) => {
    try{
        const decipher = forge.cipher.createDecipher('AES-CBC', forge.util.decode64(symmetricKey));
        decipher.start({ iv: forge.util.decode64(iv) });
        decipher.update(forge.util.createBuffer(forge.util.decode64(encryptedData), 'raw'));
        decipher.finish();
        return JSON.parse(decipher.output.toString());
    }catch(err){
        throw new Error('Unable to decrypt data');
    }
}

export const encryptAesKey = (params: any) => {
    try {
        let {encPubKey, body, URL} = params;
        let symmetricKey = forge.random.getBytesSync(16);
        let iv = forge.random.getBytesSync(16);
        var encryptedReqData : any;
        let encryptedSymmetricKey: any;
        let isBodyLength = false;
        let formObj: any = {};
        let updatedFormData = new FormData();
        if(URL.indexOf('/uploadDoc') >= 0 || URL.indexOf('/saveRemittancePayment') >= 0 || URL.indexOf('/bulkUpload/uploadSoaCsv') > 0) {
            for(var pair of body.entries()) 
                {
                    if(pair[0] !== "files"){                        
                        formObj[pair[0]] = pair[1]
                    }else{
                        updatedFormData.append('files', pair[1])
                    }
                }

                // updatedFormData.set('formData', formObj)//storage.encrypt(JSON.stringify(formObj), generateAesKey))

                // body = formObj//{...body, ...updatedFormData};
                isBodyLength = true;
        }else{
            isBodyLength = (body && Object.keys(body)?.length);
            // body = JSON.stringify(body)
        }

        if(isBodyLength){

            let cipher = forge.cipher.createCipher('AES-CBC', symmetricKey);
            cipher.start({iv: iv});
            cipher.update(forge.util.createBuffer(JSON.stringify(body), 'utf8'));
            cipher.finish();
            // encryptedReqData = cipher.output.toHex();
            encryptedReqData = forge.util.encode64(cipher.output.getBytes());

            if(Object.keys(formObj).length){
                updatedFormData.append('formData', encryptedReqData)
                encryptedReqData = body//updatedFormData
                
            }


            const publicKey = forge.pki.publicKeyFromPem(encPubKey);
            encryptedSymmetricKey = publicKey.encrypt(symmetricKey, 'RSA-OAEP');
            encryptedSymmetricKey = forge.util.encode64(encryptedSymmetricKey);

        }

        return {encryptedReqData, iv: forge.util.encode64(iv), symmetricKey: encryptedSymmetricKey};
    } catch (error) {
        throw error;
    }
};

export const encryptRequestData = async (URL:any, headers:any, body:any) => {
    return new Promise(async (resolve)=>{

        let encryptedReqData = "";
        let encPubKey = secureStorage.getItem('encryptionPublicKey');

        if(URL.indexOf('/getPublicKey') === -1){

            // body = body && Object.keys(body).length ? JSON.stringify(body) : "";
            let {encryptedReqData, iv, symmetricKey} = encryptAesKey({encPubKey, body, headers, URL});
            headers['isresponseencrypted'] = (typeof headers['isresponseencrypted'] !== 'undefined') ? headers['isresponseencrypted'] : 1;
            headers['encryptedIV'] = iv;
            headers['encryptedSymmetricKey'] = symmetricKey;
            body = {requestData:encryptedReqData};

            if(encryptedReqData instanceof FormData){

                    body = encryptedReqData//{requestData:encryptedReqData};
            }

            //if(encryptedReqData)

            resolve({body, headers, encryptedReqData})
        }else{
            resolve({body, headers, encryptedReqData})
        }
    })
}

export const removeCurrencyFormattingId = (value: any) => {
  if (!value) return '';
  // Remove currency symbol, spaces, and dots
  const numeric = value.toString().replace(/[^\d-]/g, '');
  return Number(numeric);
};

export const restrictInvalidNumberKeys = (
  e: React.KeyboardEvent<HTMLInputElement>,
  extraAllowedKeys: string[] = []
) => {
  if (extraAllowedKeys.includes(e.key)) {
    return;
  }
    // Allow Ctrl+V / Cmd+V (paste)
  const isPaste =
    (e.ctrlKey || e.metaKey) && (e.key.toLowerCase() === "v" || e.key.toLowerCase() === "c");
  if (isPaste) return;

  if (
    ((!/^\d$/.test(e.key) && !["Backspace", "Delete", "Tab", "ArrowLeft", "ArrowRight"].includes(e.key)) ||
      ["e", "E", ".", "-"].includes(e.key))
  ) {
    e.preventDefault();
  }
};

export function isValidDecimal(value:number,length:number = 4) {
  const str = value.toString();
  if (!str.includes('.')) return true;
  const decimalPart = str.split('.')[1];
  return decimalPart.length <= length;
}
export const getChangedRows = (oldArray: any, newArray: any) => {
  const changedRows: { index: number; oldRow: any; newRow: any; changedKeys: string[] }[] = [];

  for (let i = 0; i < Math.max(oldArray?.length, newArray?.length); i++) {
    const oldRow = oldArray[i] || {};
    const newRow = newArray[i] || {};

    const keys = Array.from(new Set([...Object.keys(oldRow), ...Object.keys(newRow)]));
    const changedKeys = keys.filter(key => oldRow[key] != newRow[key]);

    if (changedKeys.length > 0) {
      changedRows.push({
        index: i,
        oldRow,
        newRow,
        changedKeys
      });
    }
  }

  return changedRows;
};

export const normalizeIdDecimalAmount = (value: any, preserveTrailingDecimal = false): number | string => {
  if (value === null || value === undefined || value === '') return '';
  if (typeof value === 'number') return Number.isFinite(value) ? value : '';

  const rawValue = String(value).trim();
  if (!rawValue) return '';

  const isNegative = rawValue.includes('-');
  const numericValue = rawValue.replace(/[^\d.,]/g, '');
  if (!/\d/.test(numericValue)) return '';

  const lastDotIndex = numericValue.lastIndexOf('.');
  const lastCommaIndex = numericValue.lastIndexOf(',');
  const hasTrailingSeparator = /[.,]$/.test(numericValue);
  let decimalIndex = -1;

  if (lastDotIndex !== -1 && lastCommaIndex !== -1) {
    decimalIndex = Math.max(lastDotIndex, lastCommaIndex);
  } else if (lastDotIndex !== -1) {
    const parts = numericValue.split('.');
    const fractionPart = parts[parts.length - 1];
    if (parts.length === 2 && (hasTrailingSeparator || fractionPart.length <= 2)) {
      decimalIndex = lastDotIndex;
    }
  } else if (lastCommaIndex !== -1) {
    const parts = numericValue.split(',');
    const fractionPart = parts[parts.length - 1];
    if (parts.length === 2 && (hasTrailingSeparator || fractionPart.length <= 2)) {
      decimalIndex = lastCommaIndex;
    }
  }

  const sign = isNegative ? '-' : '';
  if (decimalIndex === -1) {
    const amount = Number(`${sign}${numericValue.replace(/[.,]/g, '')}`);
    return Number.isFinite(amount) ? amount : '';
  }

  const integerPart = numericValue.slice(0, decimalIndex).replace(/[.,]/g, '') || '0';
  const fractionPart = numericValue.slice(decimalIndex + 1).replace(/[.,]/g, '').slice(0, 2);
  const normalizedAmount = `${sign}${integerPart}.${fractionPart}`;

  if (preserveTrailingDecimal && hasTrailingSeparator) return normalizedAmount;

  const amount = Number(normalizedAmount);
  return Number.isFinite(amount) ? amount : '';
};

export const addIdDecimalCurrencyFormatting = (value: any) => {
  const rawValue = value === null || value === undefined ? '' : String(value).trim();
  if (!rawValue) return `${CURRENCY_SYMBOL} 0`;

  const hasTrailingDecimal = /[.,]$/.test(rawValue);
  const amount = Number(normalizeIdDecimalAmount(value));
  const safeAmount = Number.isFinite(amount) ? amount : 0;

  if (hasTrailingDecimal) {
    const integerAmount = safeAmount < 0 ? Math.ceil(safeAmount) : Math.floor(safeAmount);
    return `${CURRENCY_SYMBOL} ${integerAmount.toLocaleString(CURRENCY_CODE)},`;
  }

  return `${CURRENCY_SYMBOL} ${safeAmount ? safeAmount.toLocaleString(CURRENCY_CODE) : 0}`;
};
